import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { faqs } from "@/lib/weddingData";

const FAQItem = ({ item, isOpen, onToggle, idx }) => {
  return (
    <div className="border-b border-[#c9c3b3]" data-testid={`faq-item-${idx}`}>
      <button
        onClick={onToggle}
        data-testid={`faq-trigger-${idx}`}
        className="flex w-full items-start justify-between gap-8 py-8 text-left transition-colors duration-300 hover:text-[#8a8580]"
        aria-expanded={isOpen}
      >
        <div className="flex items-start gap-8">
          <span className="mt-1.5 corner-label text-[#8a8580]">0{idx + 1}</span>
          <span className="display-md">{item.q}</span>
        </div>
        <span className="mt-1 shrink-0" aria-hidden="true">
          {isOpen ? (
            <Minus strokeWidth={1.5} className="h-5 w-5" />
          ) : (
            <Plus strokeWidth={1.5} className="h-5 w-5" />
          )}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
            data-testid={`faq-content-${idx}`}
          >
            <p className="max-w-2xl body-lead pb-10 pl-12">{item.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="border-t border-[#c9c3b3] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-start justify-between">
          <p className="corner-label text-[#8a8580]">(05) — Preguntas</p>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-8"
          >
            <h2 className="display-xl">
              Los pequeños
              <br />
              detalles.
            </h2>
          </motion.div>
          <div className="col-span-12 md:col-span-4 md:pt-8">
            <p className="body-lead max-w-md">
              Todo lo que os podáis preguntar sobre el día, contado con cariño.
            </p>
          </div>
        </div>

        <div className="mt-16">
          {faqs.map((item, idx) => (
            <FAQItem
              key={item.q}
              item={item}
              idx={idx}
              isOpen={openIdx === idx}
              onToggle={() => setOpenIdx(openIdx === idx ? -1 : idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
